import _ from 'lodash';
import { findByCondition, isAbsoluteEmpty } from 'ziphy-web-shared/basic/helpers';
export function getNotesRequestOptions() {
    return {};
}
export const decodeResourceToData = (resourcesList, fieldProp) => {
    let result = [];
    let targetResources = resourcesList;
    const { backendSchema, customParams } = fieldProp;
    if (backendSchema.readTargetResourceCondition) {
        // filter resourcesList by readTargetResourceCondition
        targetResources = findByCondition.getByPath(resourcesList, backendSchema.readTargetResourceCondition, true);
    }
    _.forEach(targetResources, (resource) => {
        if (fieldProp.multi) {
            // if field is group with ability of adding more to it
            // first - extract all main values and then for each value extract customParams by index of value
            let mainValues = findByCondition.getByPath(resource, backendSchema.readValuePath, true);
            if (!_.isEmpty(mainValues)) {
                mainValues.forEach((valueString, i) => {
                    const fieldCustomParams = extractCustomParams(customParams, resource, i);
                    result.push({
                        value: fieldProp.backendSchema.readValuePrep
                            ? fieldProp.backendSchema.readValuePrep(valueString)
                            : valueString,
                        customParams: fieldCustomParams,
                    });
                });
            }
        }
        else {
            let mainValue = findByCondition.getByPath(resource, backendSchema.readValuePath);
            if (mainValue[0] || typeof mainValue[0] === 'boolean') {
                const fieldCustomParams = extractCustomParams(customParams, resource);
                if (!fieldProp.backendSchema.valueAsArray) {
                    mainValue = mainValue[0];
                }
                result.push({
                    value: fieldProp.backendSchema.readValuePrep
                        ? fieldProp.backendSchema.readValuePrep(mainValue)
                        : mainValue,
                    customParams: fieldCustomParams,
                });
            }
        }
    });
    return result;
};
const extractCustomParams = (customParamsConfig, resource, index) => {
    let result = {};
    _.forEach(customParamsConfig, (paramConfig, key) => {
        if (_.includes(Object.keys(paramConfig), 'value')) {
            paramConfig = paramConfig;
            result[key] = paramConfig.value;
            return;
        }
        if (key === 'existingResource') {
            paramConfig = paramConfig;
            if (paramConfig.keysToExcludeOnRead) {
                result[key] = _.omit(resource, paramConfig.keysToExcludeOnRead);
            }
            else {
                result[key] = resource;
            }
        }
        else if (key === 'resourceId') {
            result[key] = resource.resourceId;
        }
        else {
            paramConfig = paramConfig;
            const { backendSchema } = paramConfig;
            let { readValuePath } = backendSchema;
            if (typeof index === 'number' && _.isFunction(readValuePath)) {
                readValuePath = readValuePath(index);
            }
            const value = findByCondition.getByPath(resource, readValuePath);
            result[key] = backendSchema.readValuePrep
                ? backendSchema.readValuePrep(value[0])
                : value[0] || '';
        }
    });
    return result;
};
export const encodeFieldGroupToOneResource = (fieldGroup, fieldConfig) => {
    let result = {};
    let objectsToMerge = [];
    if (_.every(fieldGroup, (field) => field.isDeleted)) {
        const fieldWithExistingResource = _.find(fieldGroup, (filed) => filed.customParams.existingResource);
        if (fieldWithExistingResource) {
            objectsToMerge.push(encodeFieldDataToResourceData(fieldWithExistingResource, fieldConfig, 0));
        }
    }
    else {
        fieldGroup.forEach((field) => {
            if (!field.isDeleted) {
                objectsToMerge.push(encodeFieldDataToResourceData(field, fieldConfig, objectsToMerge.length));
            }
        });
    }
    if (!_.isEmpty(objectsToMerge)) {
        _.forEach(objectsToMerge, (x) => {
            result = mergeDeepObjects(result, x);
        });
    }
    return result;
};
export const encodeFieldDataToResourceData = (fieldData, fieldConfig, index) => {
    const { backendSchema, customParams } = fieldConfig;
    const { saveValuePath } = backendSchema;
    const { value, customParams: customParamsData, isDeleted } = fieldData;
    let result = {};
    let existingResult = {};
    const writeToResource = (path, value) => {
        if (typeof index === 'number') {
            _.forEach(_.concat([], path), (x) => {
                let pathItem = x;
                if (_.isFunction(x)) {
                    pathItem = x(index);
                }
                const pathArray = _.toPath(pathItem);
                const pathForBackend = pathArray.map((pathString) => strictKey(pathString));
                const oldResult = Object.assign({}, result);
                _.set(result, pathForBackend, value);
                result = mergeDeepObjects(oldResult, result);
            });
        }
        else {
            _.forEach(_.concat([], path), (x) => {
                const pathArray = _.toPath(x);
                const pathForBackend = pathArray.map((pathString) => strictKey(pathString));
                const oldResult = Object.assign({}, result);
                _.set(result, pathForBackend, value);
                result = mergeDeepObjects(oldResult, result);
            });
        }
    };
    if (isDeleted) {
        let { existingResource } = customParamsData;
        let existingResourceConfig = customParams.existingResource;
        if ('keysToExcludeOnSave' in existingResourceConfig) {
            existingResourceConfig = existingResourceConfig;
            existingResource = _.omit(existingResource, existingResourceConfig.keysToExcludeOnSave);
        }
        result = mergeDeepObjects(existingResource, { delete: true });
        return result;
    }
    if (value || _.isBoolean(value)) {
        writeToResource(saveValuePath, backendSchema.saveValuePrep ? backendSchema.saveValuePrep(value) : value);
    }
    _.forEach(customParamsData, (cValue, cKey) => {
        var _a;
        if (cValue) {
            let cParamConfig = customParams[cKey];
            if (!cParamConfig)
                return;
            if (cKey === 'existingResource') {
                cParamConfig = cParamConfig;
                existingResult = _.omit(cValue, cParamConfig.keysToExcludeOnSave);
            }
            else if (cKey === 'resourceId') {
                writeToResource(cKey, cValue);
            }
            else {
                cParamConfig = cParamConfig;
                if ((_a = cParamConfig.backendSchema) === null || _a === void 0 ? void 0 : _a.saveValuePath) {
                    writeToResource(cParamConfig.backendSchema.saveValuePath, cParamConfig.backendSchema.saveValuePrep
                        ? cParamConfig.backendSchema.saveValuePrep(cValue)
                        : cValue);
                }
            }
        }
    });
    if (_.isEmpty(existingResult) && !_.isEmpty(backendSchema.saveBaseResource)) {
        existingResult = backendSchema.saveBaseResource;
    }
    if (!_.isEmpty(existingResult)) {
        result = mergeDeepObjects(existingResult, result);
    }
    return result;
};
const strictKey = (keyToCheck) => {
    // all keys like 'dosageInstruction' need to go to backend in this exact condition without been transformed to the camel case
    // except resource_id
    if (keyToCheck !== 'resourceId' &&
        !keyToCheck.includes('|strict') &&
        keyToCheck !== _.snakeCase(keyToCheck)) {
        return `${keyToCheck}|strict`;
    }
    return keyToCheck;
};
const mergeDeepObjects = (objOne, objTwo) => {
    const merged = {};
    let base = _.cloneDeep(objOne);
    let merging = _.cloneDeep(objTwo);
    let existingKeys = _.isEmpty(base) ? [] : Object.keys(base);
    let keysToMerge = _.isEmpty(merging) ? [] : Object.keys(merging);
    existingKeys.forEach((key) => {
        if (_.includes(keysToMerge, key)) {
            keysToMerge = _.filter(keysToMerge, (y) => y !== key);
            if (_.isArray(base[key])) {
                merged[strictKey(key)] = mergeDeepArrays(base[key], merging[key]);
            }
            else if (typeof base[key] === 'string' || typeof base[key] === 'boolean') {
                merged[strictKey(key)] = merging[key];
            }
            else {
                merged[strictKey(key)] = mergeDeepObjects(base[key], merging[key]);
            }
        }
        else {
            merged[strictKey(key)] = base[key];
        }
    });
    _.forEach(keysToMerge, (leftoverKey) => {
        merged[strictKey(leftoverKey)] = merging[leftoverKey];
    });
    return merged;
};
const mergeDeepArrays = (arrOne, arrTwo) => {
    let result = [];
    arrOne.forEach((arrOneItem, index) => {
        if (!_.isEmpty(arrTwo[index])) {
            result.push(mergeDeepObjects(arrOneItem, arrTwo[index]));
        }
        else {
            result.push(mergeDeepObjects({}, arrOneItem));
        }
    });
    if (arrTwo.length > arrOne.length) {
        result = _.concat(result, arrTwo.slice(arrOne.length).map((x) => mergeDeepObjects({}, x)));
    }
    return result;
};
export const findAnswerById = (answersList, id, unsafe) => {
    let result = _.find(answersList, (x) => x.id === id);
    return unsafe ? result : result || { id, text: id, backendKey: id };
};
export const getCodeableConceptById = (answersList, id, value) => {
    const targetItem = _.find(answersList, (x) => x.id === id);
    let result = _.get(targetItem, 'codeableConcept');
    if (value) {
        result.text = value;
    }
    return result;
};
export const findAnswerByBackendKey = (answersList, backendKey, unsafe) => {
    let result = _.find(answersList, (x) => x.backendKey === backendKey);
    return unsafe
        ? result
        : result || {
            id: backendKey,
            text: backendKey,
            backendKey,
        };
};
export const extractCodingFromCodeableConcept = (codeableConceptObject) => {
    var _a;
    let result = (_a = codeableConceptObject === null || codeableConceptObject === void 0 ? void 0 : codeableConceptObject.coding) === null || _a === void 0 ? void 0 : _a[0];
    if (!_.isEmpty(result) && !result.display) {
        result.display = codeableConceptObject.text;
    }
    return result;
};
export const composeCodingToCodeableConcept = (codingObj) => {
    return typeof codingObj === 'string' // temp until we won't have any not coded data
        ? { text: codingObj }
        : {
            coding: [codingObj],
            text: codingObj.display,
        };
};
export const checkIfValueIsCompleteCoding = (value) => {
    let result = true;
    if (!value.hasOwnProperty('display') ||
        !value.hasOwnProperty('code') ||
        !value.hasOwnProperty('system')) {
        result = false;
    }
    if (!_.every(Object.values(value), (x) => !isAbsoluteEmpty(x))) {
        result = false;
    }
    return result;
};
export const isIncludes = (searchString, searchValue) => searchString.toLowerCase().includes(searchValue.toLowerCase());
export const findInSearchStrings = (list, searchValue) => {
    const newList = list.map((item) => {
        if (!item.searchString || (item.searchString && isIncludes(item.searchString, searchValue))) {
            return item;
        }
        else if (item.searchString && !isIncludes(item.searchString, searchValue)) {
            return undefined;
        }
        else if (!_.isObject(item)) {
            return item;
        }
        else if (_.isArray(item)) {
            return findInSearchStrings(item, searchValue);
        }
        let foundValues = {};
        _.forOwn(item, (value, key) => {
            if (_.isArray(value)) {
                foundValues[key] = findInSearchStrings(value, searchValue);
            }
        });
        if (!_.isEmpty(foundValues) && _.some(foundValues, (value) => !_.isEmpty(value))) {
            return Object.assign(Object.assign({}, item), foundValues);
        }
        return undefined;
    });
    return newList.filter((item) => item);
};
